import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const WalletsApiService = {
  getMyWallet: async () => {
    const response = await api.request({
      url: `/api/Wallets/GetMyWallet`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getBalance: async () => {
    const response = await api.request({
      url: `/api/Wallets/GetBalance`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getTransactions: async (params) => {
    const response = await api.request({
      url: `/api/Wallets/GetTransactions?${queryString.stringify(
        params || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  deposit: async (amount, description) => {
    const response = await api.request({
      url: `/api/Wallets/Deposit`,
      method: "POST",
      data: { amount, description },
      headers: authHeader(),
    });
    return response.data;
  },

  withdraw: async (amount, description) => {
    const response = await api.request({
      url: `/api/Wallets/Withdraw`,
      method: "POST",
      data: { amount, description },
      headers: authHeader(),
    });
    return response.data;
  },

  holdAmount: async (amount, orderId) => {
    const response = await api.request({
      url: `/api/Wallets/HoldAmount`,
      method: "POST",
      data: { amount, orderId },
      headers: authHeader(),
    });
    return response.data;
  },

  releaseHold: async (amount, orderId) => {
    const response = await api.request({
      url: `/Wallets/ReleaseHold`,
      method: "POST",
      data: { amount, orderId },
      headers: authHeader(),
    });
    return response.data;
  },
};

export default WalletsApiService;
